/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeIncrementsSection_company = {
    readonly timeRegistrationSettings: {
        readonly id: string;
        readonly granularity: string | null;
    } | null;
    readonly " $refType": "TimeIncrementsSection_company";
};
export type TimeIncrementsSection_company$data = TimeIncrementsSection_company;
export type TimeIncrementsSection_company$key = {
    readonly " $data"?: TimeIncrementsSection_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TimeIncrementsSection_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeIncrementsSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeRegistrationSettingsType",
      "kind": "LinkedField",
      "name": "timeRegistrationSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "granularity",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = 'a55f4f18f596c13ba7496de78a2f40c8';
export default node;
